import axiosInstance from '../helpers/axiosInstance'

export const sendCameraEvent = async (payload) => {
  const res = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/packing-proof/camera-events`,
    payload,
  )
  return res.data
}
